export default __webpack_public_path__ + "static/media/general_pressure_map.c9fba3da.svg";